import { $getRoot } from "lexical";
import { useCallback } from "react";
import { findNonGsmCharacters } from "./gsm-encoding";

import type { EditorState } from "lexical";

export const getNonGSMCharacters = (state: EditorState): string[] =>
  state.read(() => {
    const textNodes = $getRoot().getAllTextNodes();

    // Merge tags are replaced with recipient data before sending, so the tag
    // name itself is not part of the delivered message.
    const text = textNodes
      .filter((node) => node.getType() !== "merge-tag-v2")
      .map((node) => node.getTextContent())
      .join("");

    return [...findNonGsmCharacters(text)];
  });

export const useGetNonGSMCharacters = (): ((state: EditorState) => string[]) =>
  useCallback((state: EditorState) => getNonGSMCharacters(state), []);
